import React from 'react';

const Dummy = () => {
  return <div>Syncing Data with C360</div>;
};

export default Dummy;
